<div class="main-wrapper">
  <div class="outer-wrapper">
    <div class="payroll-summary-footer">
      <div class="payroll-subcomponent common-background-section">
        <div class="common-head">
          <div class="comon-left-head borderless" *ngIf="!showSkeleton">
            <svg (click)="goBack()" width="18" height="14" viewBox="0 0 18 14" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M17 7H1M1 7L7 13M1 7L7 1" stroke="#2D2D2E" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <h1>Add New Payroll</h1>
            <p>({{month_char}} {{month_year}})</p>
          </div>


          <div class="comon-right" #dropdownContainer *ngIf="!showSkeleton">
            <div class="apporved-numbers" *ngIf="selectionMode">
              <div class="count-box count-approved">{{ selectedUsersCount }}</div>
              out of
              <div class="count-box total-approved">{{ totalUsers }}</div>
              payrolls have been {{ currentSelectionAction === 'approved' ? 'approved' : currentSelectionAction ===
              'released' ? 'released' : '' }}
            </div>

            <div class="common-btn salary-action" *ngIf="selectionMode" (click)="cancelSelection()">
              <img src="../../../../assets/theme1/smal-icons/circle-white-cross.svg" alt="missing icon" />
              Cancel

            </div>

            <div class="common-btn salary-action" *ngIf="selectionMode" [class.disabled]="selectedUsersCount === 0"
              [attr.disabled]="selectedUsersCount === 0 ? true : null" data-toggle="modal" data-target="#comformModal">

              {{ currentSelectionAction === 'approved' ? 'Approved' : currentSelectionAction === 'released' ? 'Released'
              : '' }}
            </div>


            <div class="common-btn salary-info" *ngIf="!selectionMode " (click)="toggleOptions($event)">
              <img src="../../../../assets/theme1/smal-icons/more.svg" alt="missing icon" />
              More Options
              <img class="arrow" src="../../../../assets/theme1/smal-icons/drop-down-black.svg" alt="missing icon" />
            </div>

            <div class="options-dropdown" *ngIf="showOptions">
              <ul>
                  @if (PayrollChecks('isPreview')) {
                  <li (click)="onOptionSelect('Preview')">
                    <img src="../../../../assets/theme1/smal-icons/eye-grey.svg" alt="missing icon" />
                    Preview
                  </li>
                  }
                
                <li (click)="exportexcel()">
                  <img src="../../../../assets/theme1/smal-icons/export.svg" alt="missing icon" />
                  Export
                </li>
                <li (click)="SalaryCalcutlation()">
                  <img src="../../../../assets/theme1/smal-icons/salary-calc.svg" alt="missing icon" />
                  Salary Calculation
                </li>
              </ul>
            </div>

            <div class="common-btn salary-action" (click)="toggleactionOptions($event)" *ngIf="!selectionMode ">
              <img src="../../../../assets/theme1/smal-icons/payroll-action.svg" alt="missing icon" />
              Payroll Actions
              <img class="arrow" src="../../../../assets/theme1/smal-icons/drop-down-white.svg" alt="missing icon" />
            </div>

            <div class="options-dropdown1" *ngIf="actionOptions">
              <ul>
                <!-- Generate -->
                <li (click)="generateAllPayroll()">
                  <div class="inner-left">
                    <img src="../../../../assets/theme1/smal-icons/generate.svg" />
                    Generate All
                  </div>
                </li>
              @if (PayrollChecks('isApprove')) {
                <!-- Approve -->
                <li (click)="toggleSubMenu('approve', $event)" [class.disabled]="!exist_salary">
                  <div class="inner-left">
                    <img src="../../../../assets/theme1/smal-icons/approve.svg" />
                    Approve
                  </div>
                  <img class="right-arrow" src="../../../../assets/theme1/smal-icons/right-arrow.svg" />
                </li>
              }
              @if (PayrollChecks('isRelease')) {
                <!-- Release -->
                <li (click)="toggleSubMenu('release', $event)" [class.disabled]="!exist_salary">
                  <div class="inner-left">
                    <img class="realease-icon" src="../../../../assets/theme1/smal-icons/release-main.svg" />
                    Release
                  </div>
                  <img class="right-arrow" src="../../../../assets/theme1/smal-icons/right-arrow.svg" />
                </li>
              }
              </ul>
            </div>

            <!-- LEFT SIDE SUBMENU -->
            <div class="left-submenu" *ngIf="activeSubMenu === 'approve'">
              <ul>
                <li (click)="bulkAction('approved')">
                  <img src="../../../../assets/theme1/smal-icons/approve-all.svg" />
                  Approve All
                </li>
                <li (click)="onOptionSelect('approve-selected')">
                  <img src="../../../../assets/theme1/smal-icons/approve-single.svg" />
                  Approve Selected
                </li>
              </ul>
            </div>

            <div class="left-submenu" *ngIf="activeSubMenu === 'release'">
              <ul>
                <li (click)="bulkAction('released')">
                  <img src="../../../../assets/theme1/smal-icons/release-all.svg" />
                  Release All
                </li>
                <li (click)="onOptionSelect('release-selected')">
                  <img src="../../../../assets/theme1/smal-icons/realease select.svg" />
                  Release Selected
                </li>
              </ul>
            </div>
          </div>
          <div class="payroll-summary-header-body-item release-amount skeleton-small-div" *ngIf="showSkeleton"></div>
          <div class="payroll-summary-header-body-item release-amount skeleton-small-div" *ngIf="showSkeleton"></div>

        </div>

        <!-- <div class="filter-section">
                        <h1>Filter</h1>
                        <div class="filter-fields">
                           
                             
                            <button class="apply-filter" >Apply</button>
                        </div>
                    </div> -->




        <div class="payroll-graphs-main" *ngIf="enableGraph">
          <div class="common-graph-outer payroll-status-graph-main" *ngIf="!showSkeleton">
            <h1>Payroll Status</h1>
            <div class="status-inner-graphs">
              <div class="common-area-graph realease-graph">
                <div class="fake-graph-main">
                  <div class="gaph-fake">
                    <h1><span>Release</span>{{ statusCounts.released }}</h1>
                    <img class="count-graph" src="../../../../assets/theme1/smal-icons/released-count.png" alt="" />
                  </div>
                  <div class="gaph-fake">
                    <h1><span>Approved</span> {{ statusCounts.approved }}</h1>
                    <img class="count-graph" src="../../../../assets/theme1/smal-icons/approved-count.png" alt="" />
                  </div>
                  <div class="gaph-fake">
                    <h1><span>Draft</span> {{ statusCounts.draft }}</h1>
                    <img class="count-graph" src="../../../../assets/theme1/smal-icons/draft-count.png" alt="" />

                  </div>
                </div>
                <!-- <div class="head-graph">
                  
                  
                  <h1><span>Draft</span> {{ statusCounts.draft }}</h1>
                  <h1></h1>

                </div> -->

                <!-- <div class="area-chart-1">
                  <apx-chart
                    [series]="chartOptions.series"
                    [chart]="chartOptions.chart"
                    [stroke]="chartOptions.stroke || { curve: 'smooth', width: 2 }"
                    [fill]="chartOptions.fill || { type: 'gradient', gradient: { opacityFrom: 0.6, opacityTo: 0.05 } }">
                  </apx-chart>

                </div> -->

              </div>

            </div>

          </div>
          <div class="common-graph-outer pay-roll-summary-main" *ngIf="!showSkeleton">
            <h1>Payroll Summary</h1>
            <div class="summary-head">
              <h1><span>Total Gross Salary</span> {{ payrollService.showValues ? (totalSalary | number:'1.2-2') + '/-
                PKR' : '****' }}</h1>
            </div>
            <div class="summary-body">
              <div class="summary-body-inner">
                <img src="../../../../assets/theme1/smal-icons/total-salary-bar.png" alt="bar icon" />
                <p><span>Total Net Salary</span>{{ payrollService.showValues ? (totalReleasedSalary | number:'1.2-2') +
                  '/- PKR' : '****' }}</p>
              </div>
              <div class="summary-body-inner">
                <img src="../../../../assets/theme1/smal-icons/overtime-bar.png" alt="bar icon" />
                <p><span>Total Overtime</span>{{ payrollService.showValues ? (total_Overtime | number:'1.2-2') + '/-
                  PKR' : '****' }}</p>
              </div>
              <div class="summary-body-inner">
                <img src="../../../../assets/theme1/smal-icons/deduction-bar.png" alt="bar icon" />
                <p><span>Total Deductions</span>{{ payrollService.showValues ? (totalDeduction | number:'1.2-2') + '/-
                  PKR' : '****' }}</p>
              </div>
              <div class="summary-body-inner">
                <img src="../../../../assets/theme1/smal-icons/compensation-bar.png" alt="bar icon" />
                <p><span>Total Compensation</span>{{ payrollService.showValues ? (total_Compensation | number:'1.2-2') +
                  '/- PKR' : '****' }}</p>
              </div>
            </div>

          </div>
          <div class="common-graph-outer deduction-break-down-main" *ngIf="!showSkeleton">
            <h1>Payroll Summary</h1>
            <div class="summary-head deduction-head">
              <h1><span>Total Deductions</span> {{ payrollService.showValues ? (totalDeduction | number:'1.2-2') + '/-
                PKR' : '****' }}</h1>
            </div>
            <div class="multi-graph margin">
              <h1>{{ payrollService.showValues ? (total_tax | number:'1.0-2') : '****' }} <span>Tax</span></h1>
              <ng-container *ngFor="let item of deductionGraphData; let i = index">
                <div class="graph" [attr.data-name]="item.label" [style.--percentage]="item.percentage"
                  [style.--fill]="item.color" [style.--rotate]="cumulativePercentage(i)"></div>
              </ng-container>
            </div>
          </div>

          <div class="common-graph-section department-grpah skeleton-big-div" *ngIf="showSkeleton"></div>
          <div class="common-graph-section department-grpah skeleton-big-div" *ngIf="showSkeleton"></div>
          <div class="common-graph-section department-grpah skeleton-big-div" *ngIf="showSkeleton"></div>

        </div>



        <div class="table-container">
          <table class="responsive-table" id="excel-table">
            <thead *ngIf="!showSkeleton">
              <tr>
                <th>Full Name</th>
                <th>Gross Salary</th>
                <th>Total Deduction</th>
                <th *ngIf="hasAdvance">Advance</th>
                <th *ngIf="hasOvertime">Overtime</th>
                <th>Tax</th>
                <th *ngIf="hasLoanAmount">Loan Amount</th>
                <th *ngIf="hasOtherDeduction">Other Deduction</th>
                <th>Compensation</th>
                <th>Net Salary</th>
                <th>Status</th>
                <th class="export-ignore">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="showSkeleton">
                <td colspan="12">
                  <div class="skeleton-row" *ngFor="let n of [1,2,3,4,5,6,7,8,9,10,11,12,13,14]">
                    <div class="skeleton-cell" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12]"></div>
                  </div>
                </td>
              </tr>
              <ng-container *ngIf="!showSkeleton">
                @for (user of usersList; track user) {

                <tr [ngClass]="getPaymentTypeClass(user)">
                  <td class="user-detail custom-tooltip" (click)="editCase(user)">
                    <div class="user-image">
                      <img [src]="user?.profile_image ? user.profile_image : '../../../../assets/theme1/fake-user.png'"
                        alt="missing" />
                    </div>
                    <p>{{user?.first_name}} {{user?.last_name}}</p>

                    <p class="tooltip-text export-ignore">
                      <span>Department:</span> {{user?.department}} <br />
                      <span>Role:</span> {{user?.sub_department}}
                      <ng-container *ngIf="user?.user_salary?.[0]?.payment_type">
                        <br />
                        <span>Payment:</span> {{ formatPaymentType(user?.user_salary?.[0]?.payment_type) }}
                      </ng-container>
                    </p>
                  </td>
                  <td>{{ payrollService.showValues ? (
                    user?.user_salary?.[0]?.basic_salary !== null &&
                    user?.user_salary?.[0]?.basic_salary !== undefined
                    ? (user.user_salary[0].basic_salary | number:'1.2-2')
                    : '-') : '****' }}
                  </td>
                  <td class="deduction-td">
                    {{ payrollService.showValues ? (
                    user?.user_salary?.[0]?.total_deduction !== null &&
                    user?.user_salary?.[0]?.total_deduction !== undefined
                    ? (user.user_salary[0].total_deduction | number:'1.2-2')
                    : 0) : '****'
                    }}
                    <!-- <img
                        src="../../../../assets/theme1/info-icon.png"
                      
                        alt="missing icon"
                      /> -->

                    <svg data-toggle="modal" data-target="#deductionModal"
                      (click)="openDeductionModal(user?.user_salary[0])" width="15" height="15" viewBox="0 0 15 15"
                      fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.41667 10.0833V7.41667M7.41667 4.75H7.42333M14.0833 7.41667C14.0833 11.0986 11.0986 14.0833 7.41667 14.0833C3.73477 14.0833 0.75 11.0986 0.75 7.41667C0.75 3.73477 3.73477 0.75 7.41667 0.75C11.0986 0.75 14.0833 3.73477 14.0833 7.41667Z"
                        stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                  </td>
                  <td *ngIf="hasAdvance">
                    {{ payrollService.showValues ? (
                    user?.user_salary?.[0]?.advance_payment !== null &&
                    user?.user_salary?.[0]?.advance_payment !== undefined
                    ? (user.user_salary[0].advance_payment | number:'1.2-2')
                    : '-') : '****'
                    }}
                  </td>
                  <td *ngIf="hasOvertime">
                    {{ payrollService.showValues ? (
                    user?.user_salary?.[0]?.overtime_amount !== null &&
                    user?.user_salary?.[0]?.overtime_amount !== undefined
                    ? (user.user_salary[0].overtime_amount | number:'1.2-2')
                    : '-') : '****'
                    }}
                  </td>
                  <td>
                    {{ payrollService.showValues ? (
                    user?.user_salary?.[0]?.tax !== null &&
                    user?.user_salary?.[0]?.tax !== undefined
                    ? (user.user_salary[0].tax | number:'1.2-2')
                    : '-') : '****'
                    }}
                  </td>
                  <td *ngIf="hasLoanAmount">
                    {{ payrollService.showValues ? (
                    user?.user_salary?.[0]?.loan_deduction_amount !== null &&
                    user?.user_salary?.[0]?.loan_deduction_amount !== undefined
                    ? (user.user_salary[0].loan_deduction_amount | number:'1.2-2')
                    : '-') : '****'
                    }}
                  </td>
                  <td *ngIf="hasOtherDeduction">
                    {{ payrollService.showValues ? (
                    user?.user_salary?.[0]?.other_deduction !== null &&
                    user?.user_salary?.[0]?.other_deduction !== undefined
                    ? (user.user_salary[0].other_deduction | number:'1.2-2')
                    : '-') : '****'
                    }}
                  </td>
                  <td>
                    {{ payrollService.showValues ? (
                    user?.user_salary?.[0]?.compensation_amount !== null &&
                    user?.user_salary?.[0]?.compensation_amount !== undefined
                    ? (user.user_salary[0].compensation_amount | number:'1.2-2')
                    : '-') : '****'
                    }}
                  </td>
                  <td>
                    {{ payrollService.showValues ? (
                    user?.user_salary?.[0]?.released_salary !== null &&
                    user?.user_salary?.[0]?.released_salary !== undefined
                    ? (user.user_salary[0].released_salary | number:'1.2-2')
                    : '-') : '****'
                    }}
                    <img class="ml-1" *ngIf="user?.user_salary?.[0]?.payment_type === 'cash'"
                      src="../../../../assets/theme1/smal-icons/red-cash.svg" alt="info icon" />
                    <img class="ml-1" *ngIf="user?.user_salary?.[0]?.payment_type === 'bank_transfer'"
                      src="../../../../assets/theme1/smal-icons/bank_red.svg" alt="info icon" />
                    <img class="ml-1" *ngIf="user?.user_salary?.[0]?.payment_type === 'final'"
                      src="../../../../assets/theme1/smal-icons/red-hand.svg" alt="info icon" />
                  </td>

                  <td>
                    <div class="status-comon" [ngClass]="getStatus(user).class">
                      {{ getStatus(user).text }}
                      <div *ngIf="getStatus(user).tooltip" class="custom-tooltip">
                        <img src="../../../../assets/theme1/info-circle.png" alt="info icon" />
                        <span class="tooltip-text">{{ getStatus(user).tooltip }}</span>
                      </div>
                    </div>
                  </td>
                  <td class="action-eye">
                    <img src="../../../../assets/theme1/smal-icons/edit-05.svg" alt="eye icon"
                      (click)="editCase(user)" />
                    <svg class="svg-checkbox" [class.checked]="user.selected" *ngIf="selectionMode || user.selected"
                      (click)="toggleUser(user)" width="17" height="17" viewBox="0 0 17 17"
                      xmlns="http://www.w3.org/2000/svg">
                      <!-- Border -->
                      <rect x="0.75" y="0.75" width="15.5" height="15.5" rx="3" ry="3" class="box" fill="none"
                        stroke-width="1.5"></rect>

                      <!-- Tick mark -->
                      <path d="M4.5 8.25L7 10.75L12 5.75" class="tick" fill="none" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </td>
                </tr>


                }
              </ng-container>

              <!-- hidden row for status classes -->
              <!-- <tr>
                <td class="user-detail custom-tooltip">
                  <div class="user-image">
                    <img
                      src="../../../../assets/theme1/fake-user.png"
                      alt="missing"
                    />
                  </div>
                  <p>User Name</p>

                  <p class="tooltip-text">
                    <span>Department:</span> Graphic Designing <br />
                    <span>Role:</span> UI UX Designer
                  </p>
                </td>
                <td>10-04-2025</td>
                <td class="deduction-td">
                  12,550,000
                  <img
                    src="../../../../assets/theme1/info-icon.png"
                    data-toggle="modal"
                    data-target="#deductionModal"
                    alt="missing icon"
                  />
                </td>
                <td>550,000</td>
                <td>10,000</td>
                <td>1,250,000</td>
                <td>55,000</td>
                <td>400,000</td>
                <td>100,000</td>
                <td>
                  <div class="status-comon process">Processing</div>
                </td>
                <td class="action-eye">
                  <img
                    src="../../../../assets/theme1/smal-icons/edit-05.png"
                    alt="eye icon"
                  />
                </td>
              </tr>
              <tr>
                <td class="user-detail custom-tooltip">
                  <div class="user-image">
                    <img
                      src="../../../../assets/theme1/fake-user.png"
                      alt="missing"
                    />
                  </div>
                  <p>User Name</p>

                  <p class="tooltip-text">
                    <span>Department:</span> Graphic Designing <br />
                    <span>Role:</span> UI UX Designer
                  </p>
                </td>
                <td>20-08-2025</td>
                <td class="deduction-td">
                  12,550,000
                  <img
                    src="../../../../assets/theme1/info-icon.png"
                    alt="missing icon"
                  />
                </td>
                <td>50,000</td>
                <td>10,000</td>
                <td>1,250,000</td>
                <td>55,000</td>
                <td>400,000</td>
                <td>100,000</td>
                <td>
                  <div class="status-comon waiting">Waiting for Approval</div>
                </td>
                <td class="action-eye">
                  <img
                    src="../../../../assets/theme1/smal-icons/edit-05.png"
                    alt="eye icon"
                  />
                </td>
              </tr>
              <tr>
                <td class="user-detail custom-tooltip">
                  <div class="user-image">
                    <img
                      src="../../../../assets/theme1/fake-user.png"
                      alt="missing"
                    />
                  </div>
                  <p>User Name</p>

                  <p class="tooltip-text">
                    <span>Department:</span> Graphic Designing <br />
                    <span>Role:</span> UI UX Designer
                  </p>
                </td>
                <td>10-04-2025</td>
                <td class="deduction-td">
                  12,550,000
                  <img
                    src="../../../../assets/theme1/info-icon.png"
                    alt="missing icon"
                  />
                </td>
                <td>50,000</td>
                <td>10,000</td>
                <td>1,250,000</td>
                <td>55,000</td>
                <td>400,000</td>
                <td>100,000</td>
                <td>
                  <div class="status-comon realese">Ready to Release</div>
                </td>
                <td class="action-eye">
                  <img
                    src="../../../../assets/theme1/smal-icons/edit-05.png"
                    alt="eye icon"
                  />
                </td>
              </tr>
              <tr>
                <td class="user-detail custom-tooltip">
                  <div class="user-image">
                    <img
                      src="../../../../assets/theme1/fake-user.png"
                      alt="missing"
                    />
                  </div>
                  <p>User Name</p>

                  <p class="tooltip-text">
                    <span>Department:</span> Graphic Designing <br />
                    <span>Role:</span> UI UX Designer
                  </p>
                </td>
                <td>10-04-2025</td>
                <td class="deduction-td">
                  12,550,000
                  <img
                    src="../../../../assets/theme1/info-icon.png"
                    alt="missing icon"
                  />
                </td>
                <td>50,000</td>
                <td>10,000</td>
                <td>1,250,000</td>
                <td>55,000</td>
                <td>400,000</td>
                <td>100,000</td>
                <td>
                  <div class="status-comon change-req">
                    Changes Required
                    <div class="custom-tooltip">
                      <img
                        src="../../../../assets/theme1/info-circle.png"
                        alt="info icon"
                      />
                      <span class="tooltip-text"
                        >Attendance data conflict. Please recheck employee
                        presence</span
                      >
                    </div>
                  </div>
                </td>
                <td class="action-eye">
                  <img
                    src="../../../../assets/theme1/smal-icons/edit-05.png"
                    alt="eye icon"
                  />
                </td>
              </tr>
              <tr>
                <td class="user-detail custom-tooltip">
                  <div class="user-image">
                    <img
                      src="../../../../assets/theme1/fake-user.png"
                      alt="missing"
                    />
                  </div>
                  <p>User Name</p>

                  <p class="tooltip-text">
                    <span>Department:</span> Graphic Designing <br />
                    <span>Role:</span> UI UX Designer
                  </p>
                </td>
                <td>10-04-2025</td>
                <td class="deduction-td">
                  12,550,000
                  <img
                    src="../../../../assets/theme1/info-icon.png"
                    alt="missing icon"
                  />
                </td>
                <td>550,000</td>
                <td>50,000</td>
                <td>1,250,000</td>
                <td>55,000</td>
                <td>400,000</td>
                <td>100,000</td>
                <td>
                  <div class="status-comon release">Released</div>
                </td>
                <td class="action-eye">
                  <img
                    src="../../../../assets/theme1/smal-icons/edit-05.png"
                    alt="eye icon"
                  />
                </td>
              </tr>
              <tr>
                <td class="user-detail custom-tooltip">
                  <div class="user-image">
                    <img
                      src="../../../../assets/theme1/fake-user.png"
                      alt="missing"
                    />
                  </div>
                  <p>User Name</p>

                  <p class="tooltip-text">
                    <span>Department:</span> Graphic Designing <br />
                    <span>Role:</span> UI UX Designer
                  </p>
                </td>
                <td>10-04-2025</td>
                <td class="deduction-td">
                  12,550,000
                  <img
                    src="../../../../assets/theme1/info-icon.png"
                    alt="missing icon"
                  />
                </td>
                <td>550,000</td>
                <td>10,000</td>
                <td>1,250,000</td>
                <td>55,000</td>
                <td>400,000</td>
                <td>100,000</td>
                <td>
                  <div class="status-comon cancel">Canceled</div>
                </td>
                <td class="action-eye">
                  <img
                    src="../../../../assets/theme1/smal-icons/edit-05.png"
                    alt="eye icon"
                  />
                </td>
              </tr>
              <tr>
                <td class="user-detail custom-tooltip">
                  <div class="user-image">
                    <img
                      src="../../../../assets/theme1/fake-user.png"
                      alt="missing"
                    />
                  </div>
                  <p>User Name</p>

                  <p class="tooltip-text">
                    <span>Department:</span> Graphic Designing <br />
                    <span>Role:</span> UI UX Designer
                  </p>
                </td>
                <td>10-04-2025</td>
                <td class="deduction-td">
                  12,550,000
                  <img
                    src="../../../../assets/theme1/info-icon.png"
                    alt="missing icon"
                  />
                </td>
                <td>50,000</td>
                <td>10,000</td>
                <td>1,250,000</td>
                <td>55,000</td>
                <td>400,000</td>
                <td>100,000</td>
                <td>
                  <div class="status-comon draft">Draft</div>
                </td>
                <td class="action-eye">
                  <img
                    src="../../../../assets/theme1/smal-icons/edit-05.png"
                    alt="eye icon"
                  />
                </td>
              </tr> -->
            </tbody>
            <tfoot *ngIf="!showSkeleton">
              <tr>
                <td>Total Details</td>
                <td>{{ payrollService.showValues ? (totalSalary | number:'1.2-2') : '****' }}</td>
                <td class="deduction-td">
                  {{ payrollService.showValues ? (totalDeduction | number:'1.2-2') : '****' }}
                  <img src="../../../../assets/theme1/smal-icons/white-info.svg" (click)="totalmodalDeduction({
                              absents: total_absents_count,
                              absents_amount: total__absents,
                              late_check_in: total_lateCheckin_count,
                              late_check_in_amount: total_lateCheckin,
                              short_hours: total_shourtHours_count,
                              short_hours_amount: total_shourtHours,
                              unpaid_leaves: total_unpaidLeaves,
                              unpaid_leaves_amount: total_unpaidLeaves
                          })" data-toggle="modal" data-target="#deductionModal" alt="missing icon" />
                </td>
                <td *ngIf="hasAdvance">{{ payrollService.showValues ? (total_Advance | number:'1.2-2') : '****' }}</td>
                <td *ngIf="hasOvertime">{{ payrollService.showValues ? (total_Overtime | number:'1.2-2') : '****' }}
                </td>
                <td>{{ payrollService.showValues ? (total_tax | number:'1.2-2') : '****' }}</td>
                <td *ngIf="hasLoanAmount">{{ payrollService.showValues ? (loan_amount | number:'1.2-2') : '****' }}</td>
                <td *ngIf="hasOtherDeduction">{{ payrollService.showValues ? (total_otherDeduction | number:'1.2-2') :
                  '****' }}</td>
                <td>{{ payrollService.showValues ? (total_Compensation | number:'1.2-2') : '****' }}</td>
                <td>{{ payrollService.showValues ? (totalReleasedSalary | number:'1.2-2') : '****' }}</td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- deduction modal -->
<div class="modal fade payroll-modal pl-0" id="deductionModal" tabindex="-1" role="dialog" aria-labelledby="basicModal"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content payroll-modal-content">
      <div class="modal-header payroll-modal-header justify-content-center deduction-header">
        <h1>Total Deductions</h1>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img src="../../../../assets/theme1/smal-icons/circle-black-cross.png" alt="image" />
        </button>
      </div>

      <div class="modal-body payroll-modal-body deduction-modal-body">
        <div class="dedcution-modal-table">
          <div class="comon-div-main deduction-category">
            <div class="comon-div modal-comon-head">
              <h1 class="title-head">Category</h1>
            </div>
          </div>
          <div class="comon-div-main deduction-duration">
            <div class="comon-div modal-comon-head">
              <h1 class="title-head">Duration</h1>
            </div>
          </div>
          <div class="comon-div-main final-deduction">
            <div class="comon-div modal-comon-head">
              <h1 class="title-head">Deduction</h1>
            </div>
          </div>
        </div>
        <div class="dedcution-modal-table">
          <div class="comon-div-main deduction-category">
            <div class="comon-div modal-comon-head category-head">
              <h1>Absents</h1>
            </div>
          </div>
          <div class="comon-div-main deduction-duration">
            <div class="comon-div modal-comon-head duration-text-center">
              <h1>{{ payrollService.showValues ? ((selectedPayroll?.absents || 0) | number:'1.2-2') : '****' }}</h1>
            </div>
          </div>
          <div class="comon-div-main final-deduction">
            <div class="comon-div modal-comon-head">
              <h1>{{ payrollService.showValues ? (((selectedPayroll?.absents_amount || 0) | number:'1.2-2') + '/-PKR') :
                '****' }}</h1>
            </div>
          </div>
        </div>
        <div class="dedcution-modal-table">
          <div class="comon-div-main deduction-category">
            <div class="comon-div modal-comon-head category-head">
              <h1>Late Check In</h1>
            </div>
          </div>
          <div class="comon-div-main deduction-duration">
            <div class="comon-div modal-comon-head duration-text-center">
              <h1>{{ payrollService.showValues ? ((selectedPayroll?.late_check_in || 0) | number:'1.2-2') : '****' }}
              </h1>
            </div>
          </div>
          <div class="comon-div-main final-deduction">
            <div class="comon-div modal-comon-head">
              <h1>{{ payrollService.showValues ? (((selectedPayroll?.late_check_in_amount || 0) | number:'1.2-2') +
                '/-PKR') : '****' }}</h1>
            </div>
          </div>
        </div>
        <div class="dedcution-modal-table">
          <div class="comon-div-main deduction-category">
            <div class="comon-div modal-comon-head category-head">
              <h1>Short Hours</h1>
            </div>
          </div>
          <div class="comon-div-main deduction-duration">
            <div class="comon-div modal-comon-head duration-text-center">
              <h1>{{ payrollService.showValues ? ((selectedPayroll?.short_hours || 0) | number:'1.2-2') : '****' }}</h1>
            </div>
          </div>
          <div class="comon-div-main final-deduction">
            <div class="comon-div modal-comon-head">
              <h1>{{ payrollService.showValues ? (((selectedPayroll?.short_hours_amount || 0) | number:'1.2-2') +
                '/-PKR') : '****' }}</h1>
            </div>
          </div>
        </div>
        <div class="dedcution-modal-table">
          <div class="comon-div-main deduction-category">
            <div class="comon-div modal-comon-head category-head">
              <h1>Unpaid Leaves</h1>
            </div>
          </div>
          <div class="comon-div-main deduction-duration">
            <div class="comon-div modal-comon-head duration-text-center">
              <h1>{{ payrollService.showValues ? ((selectedPayroll?.unpaid_leaves || 0) | number:'1.2-2') : '****' }}
              </h1>
            </div>
          </div>
          <div class="comon-div-main final-deduction">
            <div class="comon-div modal-comon-head">
              <h1>{{ payrollService.showValues ? (((selectedPayroll?.unpaid_leaves_amount || 0) | number:'1.2-2') +
                '/-PKR') : '****' }}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- approval and released conformation modal -->
<div class="modal fade payroll-modal pl-0" id="comformModal" tabindex="-1" role="dialog" aria-labelledby="basicModal"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content payroll-modal-content">
      <div class="modal-header justify-content-center deduction-header borderless ">
        <h1></h1>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img src="../../../../assets/theme1/smal-icons/circle-black-cross.png" alt="image" />
        </button>
      </div>

      <div class="modal-body conformation-modal-body">
        <img src="../../../../assets/theme1/conformation.png" alt="missing image">
        <h1>Are You Sure You want to {{currentSelectionAction === 'approved' ? 'Approved' : currentSelectionAction ===
          'released' ? 'Released' : '' }}?</h1>
      </div>
      <div class="modal-footer conformation-modal-footer borderless">
        <div class="modal-action-buttons">
          <div class="common-btn cancel-modal" data-dismiss="modal" aria-label="Close" (click)="cancelSelection()">
            Cancel
          </div>
          <div class="common-btn salary-action" (click)="actionConformation(
                currentSelectionAction === 'approved'
                  ? 'approved'
                  : currentSelectionAction === 'released'
                  ? 'released'
                  : ''
              )">
            {{ currentSelectionAction === 'approved' ? 'Approved' : currentSelectionAction === 'released' ? 'Released' :
            '' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>




<!-- Error case modal conformation modal -->
<div class="modal fade payroll-modal pl-0" id="errorModal" tabindex="-1" role="dialog" aria-labelledby="basicModal"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content payroll-modal-content">
      <div class="modal-header justify-content-center deduction-header borderless ">
        <h1></h1>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img src="../../../../assets/theme1/smal-icons/circle-black-cross.png" alt="image" />
        </button>
      </div>

      <div class="modal-body conformation-modal-body">
        <img src="../../../../assets/theme1/warning.png" alt="missing image">
        <h1>No User Selected!</h1>
        <p>Please select at least one user.</p>
      </div>
      <div class="modal-footer conformation-modal-footer borderless">
        <div class="modal-action-buttons">
          <div class="common-btn cancel-modal" data-dismiss="modal" aria-label="Close" (click)="cancelSelection()">
            Cancel
          </div>
          <div class="common-btn salary-action" (click)="actionConformation(
                currentSelectionAction === 'approved'
                  ? 'approved'
                  : currentSelectionAction === 'released'
                  ? 'released'
                  : ''
              )">
            {{ currentSelectionAction === 'approved' ? 'Approved' : currentSelectionAction === 'released' ? 'Released' :
            '' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>